import { ArrowRight2, DollarCircle, Link2, PlayCircle, ShoppingBag } from "iconsax-reactjs"
import { XIcon } from "lucide-react"
import React from "react"

import { TikTokIcon } from "@/components/shared"
import { Image, Skeleton } from "@/components/ui"
import { COMMISSION_LABELS, GUIDE_LABELS } from "@/modules/helpers/tap-constants"

interface CommissionRateBannerProps {
  commissionRate?: number
  maxCommission?: string
}

export function CommissionRateBanner({ commissionRate, maxCommission }: CommissionRateBannerProps) {
  return (
    <div className="py-4 px-4 rounded-2xl bg-[#F6F2FD]">
      <div className="flex gap-2">
        <div className="flex flex-row items-center gap-1">
          <TikTokIcon />
          <XIcon color="#76127F" size={16} />
          <div className="w-5 h-5 rounded-sm overflow-hidden flex items-center justify-center">
            <Image src={"/favicon-96x96.png"} alt="logo" className="w-full h-full object-cover" />
          </div>
        </div>
      </div>
      <span className="text-sm font-semibold mt-1 text-[#76127F]">
        {COMMISSION_LABELS.EXCLUSIVE_HIGH_COMMISSION}
      </span>
      <div className="gap-1 text-[#3C1449] mt-2 flex items-center justify-between">
        <span className="text-sm font-bold">{commissionRate} (%)</span>
        <span className="text-sm font-normal flex gap-1 items-end">
          {COMMISSION_LABELS.COMMISSION_UP_TO}
          <span className="font-normal">{maxCommission}đ</span> {COMMISSION_LABELS.PER_ORDER}
        </span>
      </div>
    </div>
  )
}

interface AffiliateGuideItemProps {
  icon: React.ReactNode
  label: string
}

const AffiliateGuideItem: React.FC<AffiliateGuideItemProps> = ({ icon, label }) => (
  <div className="flex flex-col justify-center">
    <div className="w-8 py-1 flex items-center justify-center rounded-full">{icon}</div>
    <p className="font-light text-[7px] tiny:text-[8px] max-w-[80px]">{label}</p>
  </div>
)

export function AffiliateGuide() {
  return (
    <div className="bg-white p-3 rounded-xl shadow-xs">
      <p className="font-semibold text-sm text-primary-800">{GUIDE_LABELS.GUIDE_TITLE}</p>

      <div className="flex items-center gap-1 mt-2 rounded-lg justify-between">
        <AffiliateGuideItem
          icon={<Link2 size={16} className="text-primary" />}
          label={GUIDE_LABELS.ADD_TO_SHOWCASE}
        />
        <ArrowRight2 size={8} color="#000" />
        <AffiliateGuideItem
          icon={<ShoppingBag size={16} className="text-primary" />}
          label={GUIDE_LABELS.ADD_TO_TIKTOK}
        />
        <ArrowRight2 size={8} color="#000" />
        <AffiliateGuideItem
          icon={<PlayCircle size={16} className="text-primary" />}
          label={GUIDE_LABELS.CREATE_AD_VIDEO}
        />
        <ArrowRight2 size={8} color="#000" />
        <AffiliateGuideItem
          icon={<DollarCircle size={16} className="text-primary" />}
          label={GUIDE_LABELS.EARN_COMMISSION}
        />
      </div>
    </div>
  )
}

export function CampaignLoadingSkeleton() {
  return (
    <div className="flex gap-2 flex-col h-fit lg:flex-row">
      <div className="flex-1 aspect-square">
        <Skeleton className="flex-1 aspect-square" />
      </div>
      <div className="flex flex-col gap-2 flex-1">
        <Skeleton className="h-14 w-full" />
        <Skeleton className="h-8 w-full" />
        <Skeleton className="h-4 w-full" />
        <Skeleton className="h-4 w-full" />
        <Skeleton className="h-8 w-full" />
        <Skeleton className="h-14 w-full" />
        <Skeleton className="h-8 w-full" />
        <div className="mt-auto flex gap-2">
          <Skeleton className="h-8 w-8" />
          <Skeleton className="h-8 w-8" />
          <Skeleton className="h-8 flex-1" />
        </div>
      </div>
    </div>
  )
}
